import React, { Component, Fragment } from 'react';
import ReactTooltip from "react-tooltip";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { formStyleConstants } from '../../utils/constants/form-style-constants';
import { isEmpty } from '../../utils/obj-utils';
import FieldHeader from './FieldHeader';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

class FormTextInput extends Component {
    constructor(props) {
        super(props);
        const { validState, defaultValue } = this.props;

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCallback = this.handleChangeCallback.bind(this);
        this.handleFieldIsFilled = this.handleFieldIsFilled.bind(this);
        this.getFieldType = this.getFieldType.bind(this);

        this.initialState = {
            defaultValue: defaultValue || formMessageConstants.emptyString,
            isFilled: !isEmpty(defaultValue),
            isValid: true,
            errorMessage: ''
        };
        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }
        this.state = this.initialState;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.defaultValue === nextProps.defaultValue) {
            return;
        }

        this.setState((state) => ({
            ...state,
            defaultValue: nextProps.defaultValue || formMessageConstants.emptyString,
            isFilled: !isEmpty(nextProps.defaultValue)
        }));
    }

    handleChange(event) {
        const { value } = event.target;
        const { onChange } = this.props;
        onChange(event);
        this.setState(
            (prevState) => ({
                ...prevState,
                defaultValue: value
            })
        );
    }

    handleChangeCallback() {
        const { onChange } = this.props;
        onChange(this.state);
    }

    handleBlur(event) {
        const { onBlur } = this.props;
        const { value } = event.target;
        this.handleFieldIsFilled(value);
        if (onBlur) {
            onBlur(event);
        }
    }

    handleFieldIsFilled(value) {
        const isFilled = value !== '';
        this.setState((state) => ({ ...state, isFilled }));
    }

    getFieldType() {
        const { isPassword } = this.props;
        return isPassword ? 'password' : 'text';
    }

    render() {
        const {
            name,
            autocompleteValue,
            label,
            isHidden,
            headerTitle,
            headerText,
            size,
            isPassword,
            validState,
            formRef,
            isDisabled,
            tooltipText,
        } = this.props;

        const { isValid, errorMessage } = validState || this.state;
        const { defaultValue, isFilled } = this.state;
        const fieldClassName = name || formStyleConstants.customFieldClassName;

        return (
            <Fragment>
                <FieldHeader
                    fieldName={name}
                    headerTitle={headerTitle}
                    headerText={headerText}
                    textClassName={isPassword ? 'password-info' : 'text-info'}>
                </FieldHeader>
                <div
                    ref={formRef}
                    className={`form-field auto-mt-xs ${fieldClassName.toLowerCase()}-field ${size || formMessageConstants.emptyString} ${isFilled ? formStyleConstants.isFilled : ''} ${!isValid ? formStyleConstants.isInvalid : ''}`}
                    data-dc-component='form-field'
                    data-form-control
                    style={{ display: isHidden ? 'none' : 'block' }}
                >
                     {
                        !isEmpty(tooltipText) ? <div className='tooltip-icon-abs'><div data-tip={tooltipText} data-for='disabledTooltip' data-place='left'><FontAwesomeIcon icon={faInfoCircle} /></div>
                            <ReactTooltip id="disabledTooltip" /></div> : null
                    }
                    <input
                        className='form-field__input'
                        type={this.getFieldType()}
                        autoComplete={autocompleteValue}
                        id={name}
                        name={name}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        value={defaultValue}
                        disabled={isDisabled}
                    />
                    <label className='form-field__label' htmlFor={name}>
                        {label}
                    </label>
                   
                    {!isValid ? <ul className="form-field__error-list filled">
                        <li className="form-field__error-item">{errorMessage}</li>
                    </ul> : null}
                </div>
            </Fragment>
        );
    }
}

FormTextInput.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    autocompleteValue: PropTypes.string,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    size: PropTypes.string,
    isPassword: PropTypes.bool,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    validState: PropTypes.object,
    isDisabled: PropTypes.bool,
    tooltipText: PropTypes.string
};

export default FormTextInput;
